export const screenName = 'ManagementFee';

export enum ManagementFeeStatus {
  Unknown = -1,
  Created = 0,
  Scheduled = 1,
  Processed = 2,
  Sent = 3,
  Rejected = 4,
  Cancelled = 5,
  Expired = 6,
  Error = 7,
}

export enum ManagementFeeCustomerError {
  Unknown = -1,
  AccountIsEmpty = 1,
  AmmountIsEmpty = 2,
  AmountNumericGreaterThan0 = 3,
  CustomerNotFoundForManager = 4,
  GetCustomerError = 5,
  CustomerIsBlocked = 6,
  UnavailableBalance = 7,
  DuplicateRecord = 8,
  FeeAlreadySent = 9,
  SinacorCustomerNotFoundForManager = 10,
  SinacorCustomerNotLinked = 11,
  BalanceLessThanFeeAmount = 12,
}
